import { z } from "zod";

export const INVALID_ADDRESS_RESPONSE_CONTRACT = "INVALID_ADDRESS_RESPONSE_CONTRACT";

const addressListSchema = z.array(
	z.object({
		guid: z.string().min(1),
		idAddressType: z.number(),
		delivery: z.boolean(),
		street: z.string(),
		number: z.string().nullish(),
		complement: z.string().nullish(),
		municipality: z.object({
			zipCode: z.string(),
			name: z.string(),
			city: z.object({
				name: z.string(),
				state: z.object({ name: z.string() }),
			}),
		}),
	}),
);

export function validateAddressList(value: unknown): void {
	if (!addressListSchema.safeParse(value).success) {
		throw new Error(INVALID_ADDRESS_RESPONSE_CONTRACT);
	}
}
